export default __webpack_public_path__ + "static/media/modalDetailBg.685df201.png";